import React from 'react';
import classnames from 'classnames';
import margin from 'scy/margin.mod.scss';
import { useBackground } from 'scy/Background';
import styles from './styles.mod.scss';

export default function Text({
  defaultTag = 'span',
  variant = 'body',
  color,
  tag,
  marginClass = margin.all0,
  uppercase,
  colorClass,
  className,
  ...props
}) {
  const Tag = tag ? tag : defaultTag;
  const variantClassName = styles[variant];
  const background = useBackground();
  const colorClassName = colorClass || getColorClassName(color, background);
  return (
    <Tag
      className={classnames(
        variantClassName,
        colorClassName,
        marginClass,
        { [styles.uppercase]: uppercase },
        className
      )}
      {...props}
    />
  );
}

function getColorClassName(color, background) {
  if (color === 'danger') return styles.danger;
  if (color === 'success') return styles.success;
  if (color === 'secondary') {
    return background.isDark ? styles.darkBgSecondary : styles.secondary;
  }
  if (color === 'accent') {
    return background.isMuted ? styles.mutedBgAccent : styles.accent;
  }
  return background.isDark || background.isAccent
    ? styles.darkBgPrimary
    : styles.primary;
}
